export const playerKDPeriods = [
    { value: 'alltime', label: 'Todo o tempo' },
    { value: 'month', label: 'Últimos 30 dias' },
    { value: 'week', label: 'Últimos 7 dias' },
    { value: 'day', label: 'Hoje' },
] as const;

export type PlayerKDPeriod = typeof playerKDPeriods[number]['value'];
export const isPlayerKDPeriod = (value: unknown): value is PlayerKDPeriod =>
    playerKDPeriods.some(period => period.value === value);

export type PlayerKDStats = {
    kills: number;
    deaths: number;
    headshotKills: number;
    kd: number;
    headshotSampleKills?: number;
};

export const PLAYER_KD_REFRESH_INTERVAL_MS = 15 * 60_000;

export const playerKDSortKeys = ['kills', 'deaths', 'kd', 'hs'] as const;
export type PlayerKDSortKey = typeof playerKDSortKeys[number];
export const isPlayerKDSortKey = (key: string): key is PlayerKDSortKey =>
    playerKDSortKeys.some(value => value === key);

export function getPlayerKDValue(stats: PlayerKDStats | null, key: PlayerKDSortKey): number {
    if (!stats) return -1;
    const sampledKills = stats.headshotSampleKills ?? stats.kills;
    if (key === 'hs' && stats.kills > 0 && sampledKills === 0) return -1;
    return key === 'hs' ? (sampledKills ? stats.headshotKills / sampledKills * 100 : 0) : stats[key];
}

export type PlayerKDResponse = {
    stats: PlayerKDStats | null;
    period: PlayerKDPeriod;
    error?: string;
};
